import { FC, useState } from 'react';
import { IonFab, IonFabButton, IonModal } from '@ionic/react';
import { AllieChatboxOutlineIcon } from '../../../styling/icons';
import {
  AllieButton,
  AllieContent,
  AllieFabList,
  AllieHeader,
  AllieText,
} from '../../../components';
import { AllieToolbarStyled, StyledAllieArrowBackOutlineIcon } from './ChatFloatButton.styles';
import { isMobile } from '../../../common/utils';

export interface AllieChatButtonProps {
  children: React.ReactNode;
  title: string;
}

export const AllieChatFloatButton: FC<AllieChatButtonProps> = ({ children, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <IonFab slot="fixed" vertical="bottom" horizontal="end">
      <IonFabButton onClick={() => setIsOpen(true)}>
        <AllieChatboxOutlineIcon />
      </IonFabButton>
      {isMobile ? (
        <IonModal isOpen={isOpen}>
          <AllieHeader>
            <AllieToolbarStyled>
              <div slot="start">
                <AllieButton
                  allieSize="xs"
                  allieType="secondary"
                  fill="clear"
                  onclick={() => setIsOpen(false)}
                >
                  <StyledAllieArrowBackOutlineIcon slot="icon-only" />
                </AllieButton>
                <AllieText type="h3" color="neutral-70">
                  {title}
                </AllieText>
              </div>
            </AllieToolbarStyled>
          </AllieHeader>
          <AllieContent>{children}</AllieContent>
        </IonModal>
      ) : (
        <AllieFabList side="top" style={{ left: -350 }}>
          {children}
        </AllieFabList>
      )}
    </IonFab>
  );
};
